import React from 'react';
import EmbedPreferenceIframe from '@intelligence/components/EmbedPreferenceIframe';
import {
  IP_COLLABORATION_EMBED_URL,
  isIpCollaborationEnabled,
} from '@intelligence/_config/ipCollaboration';
import usePageLog from '@intelligence/v3/_hooks/usePageLog';
import './index.scss';

export default function IpCollaboration() {
  usePageLog('pageIpCollaboration');

  if (!isIpCollaborationEnabled()) {
    return null;
  }

  return (
    <EmbedPreferenceIframe
      url={IP_COLLABORATION_EMBED_URL}
      className="dbi-ip-collaboration-embed"
    />
  );
}
